import { render } from "./UploadListView.vue?vue&type=template&id=3ba32362"
import script from "./UploadListView.vue?vue&type=script&lang=js"
export * from "./UploadListView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__